function setCookie(cName, cValue, expDays) {
  
        let data = encodeURIComponent(cValue);
        //let dataSize = data.length;
  //console.log("dataSize: ", dataSize);
        let date = new Date();
        date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000));
        const expires = "expires=" + date.toUTCString();
        //document.cookie = cName + "DataSize=" + dataSize + "; " + expires + "; path=/";
        document.cookie = cName + "=" + data + "; " + expires + "; path=/";
        
}

function getCookie(cName) {
    const name = cName + "=";
    /*
    const cDecoded = decodeURIComponent(document.cookie); //to be careful
    const cArr = cDecoded .split('; ');
    let res;
    cArr.forEach(val => {
        if (val.indexOf(name) === 0) res = val.substring(name.length);
    })
    return res;
  */
    const cDecoded = document.cookie; //to be careful
    const cArr = cDecoded .split('; ');
    let res;
    cArr.forEach(val => {
        if (val.indexOf(name) === 0) res = val.substring(name.length);
    })
    return decodeURIComponent(res);
  
}